import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-16 bg-secondary-900 text-secondary-100 md:mt-20">
      <div className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-lg font-bold text-background-50">
                瓜
              </span>
              <span className="font-heading text-lg font-bold text-background-50">美日吃瓜</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-secondary-200">
              专注美国与日本政商圈的深度档案整理，追踪政客丑闻、财阀内幕、官员贪腐、选举黑幕、企业造假与学术不端六大方向的公开线索。
            </p>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold tracking-wide text-background-50">
              内容栏目
            </h3>
            <ul className="mt-4 space-y-2.5">
              {categories.map((category) => (
                <li key={category.slug}>
                  <Link
                    to={`/category/${category.slug}`}
                    className="text-sm text-secondary-200 transition-colors hover:text-accent-300"
                  >
                    {category.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold tracking-wide text-background-50">
              关于本站
            </h3>
            <ul className="mt-4 space-y-2.5">
              <li>
                <Link to="/about" className="text-sm text-secondary-200 transition-colors hover:text-accent-300">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-sm text-secondary-200 transition-colors hover:text-accent-300">
                  常见问题
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-secondary-200 transition-colors hover:text-accent-300">
                  联系与投稿
                </Link>
              </li>
              <li>
                <Link to="/search?q=调查" className="text-sm text-secondary-200 transition-colors hover:text-accent-300">
                  站内检索
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold tracking-wide text-background-50">
              读者联络
            </h3>
            <ul className="mt-4 space-y-3 text-sm text-secondary-200">
              <li className="flex items-start gap-2">
                <span className="mt-0.5 flex h-4 w-4 items-center justify-center text-accent-400">
                  <i className="ri-mail-line" />
                </span>
                editor@meirichigua.com
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-0.5 flex h-4 w-4 items-center justify-center text-accent-400">
                  <i className="ri-time-line" />
                </span>
                每周一至周五 10:00 - 19:00
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-0.5 flex h-4 w-4 items-center justify-center text-accent-400">
                  <i className="ri-shield-keyhole-line" />
                </span>
                线索提供者可选择匿名，来源信息严格保密
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-secondary-700 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-secondary-300">
            © {year} 美日吃瓜 · 内容基于公开材料整理，涉及的个人与机构均以可核对信息为准
          </p>
          <p className="text-xs text-secondary-400">
            本站内容不构成任何法律意见，引用请注明出处
          </p>
        </div>
      </div>
    </footer>
  );
}